import type { ShipmentCreationStep, ShipmentFlowConfig } from './types';

const DEFAULT_STEP_ORDER: ShipmentCreationStep[] = ['basics', 'documents', 'cargo', 'summary'];

export const OUTBOUND_CONFIG: ShipmentFlowConfig = {
  flowType: 'outbound',
  shipmentType: 'Outbound',
  bookingMode: 'Outbound',
  stepOrder: ['basics', 'cargo', 'documents', 'summary'],
  cargoMode: 'stock-allocation',
  basePath: '/outbound',
  i18nNamespace: 'shipmentCreation',
  sliceName: 'createOutbound',
  toastIdPrefix: 'outbound',
  breadcrumbLabel: 'Outbound',
  flowLabel: 'Outbound',
};

export const INBOUND_CONFIG: ShipmentFlowConfig = {
  flowType: 'inbound',
  shipmentType: 'Inbound',
  bookingMode: 'Inbound',
  stepOrder: DEFAULT_STEP_ORDER,
  cargoMode: 'stock-allocation',
  basePath: '/inbound',
  i18nNamespace: 'shipmentCreation',
  sliceName: 'createInbound',
  toastIdPrefix: 'inbound',
  breadcrumbLabel: 'Inbound',
  flowLabel: 'Inbound',
};

export const ROAD_TRANSPORT_CONFIG: ShipmentFlowConfig = {
  flowType: 'road-transport',
  shipmentType: 'RoadTransport',
  bookingMode: null,
  stepOrder: ['basics', 'cargo', 'documents', 'summary'],
  cargoMode: 'cargo-lines',
  basePath: '/road-transport',
  i18nNamespace: 'createRoadTransport',
  sliceName: 'createRoadTransport',
  toastIdPrefix: 'road-transport',
  breadcrumbLabel: 'Road Transport',
  flowLabel: 'Road Transport',
};
